<template>
  <section class="lms-container">
    <div class="content">
    <div class="breadcrumb" style="border: none !important;"></div>

      <tabs>
        <tab v-if="userType==0" title="Dashboard">
          <dashboard v-if="dailyChartData" :dailyChartData="dailyChartData" />
        </tab>
        <tab title="Progresso">
          <student-report
            @getStudentData="getStudentData"
            :users="users"
            :courses="courses"
            :studentData="studentData"
            :loadingData="loadingData"
          />
        </tab>
        <tab v-if="userType!=2" title="Pagamentos">
          <payments-report
            @getPaymentData="getPayments"
            :users="users"
            :courses="courses"
            :paymentData="payments"
            :loadingData="loadingData"
          />
        </tab>
        <tab v-if="userType==0" title="Inativos">
          <inactives-report :inactivesData="inactives" :loadingData="loadingData" />
        </tab>
      </tabs>
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>

<script>
import axios from "axios";
import StudentReport from "./Student";
import PaymentsReport from "./Payments";
import InactivesReport from "./Inactives";
import Dashboard from "./Dashboard";

export default {
  data() {
    return {
      userType: this.$store.getters.user.type,
      selectedStudent: 0,
      selectedCourse: 0,
      studentData: [],
      users: [],
      courses: [],
      payments: [],
      inactives: [],
      paymentChartData: null,
      dailyChartData: null,
      loadingData: false
    };
  },
  components: {
    Dashboard,
    InactivesReport,
    StudentReport,
    PaymentsReport
  },
  methods: {
    studentProgress(watched, total) {
      return (watched / total) * 100 + "%";
    },
    getStudentData(selectedStudentId, selectedCourseId) {
      this.loadingData = true;
      const path = this.$global.endpoint + "/analytics/getstudentdata";
      axios
        .post(path, {
          userId: selectedStudentId,
          courseId: selectedCourseId
        })
        .then(res => {
          this.studentData = res.data;
          this.loadingData = false;
        })
        .catch(error => {
          console.error(error);
          this.loadingData = false;
        });
    },
    getUsers() {
      const path = this.$global.endpoint + "/user/admin/getall";
      axios
        .post(path, {
          type: 1
        })
        .then(res => {
          this.users = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    getCourses() {
      const path = this.$global.endpoint + "/course/getall";
      axios
        .get(path)
        .then(res => {
          this.courses = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    getPayments(userId) {
      const path = this.$global.endpoint + "/payment/getall";
      axios
        .post(path, {
          userId: userId
        })
        .then(res => {
          this.payments = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    getInactives() {
      const path = this.$global.endpoint + "/user/getinactives";
      axios
        .get(path)
        .then(res => {
          this.inactives = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    getPaymentData() {
      this.$store.dispatch("loadProductSales");
      this.$store.dispatch("loadMonthSales");
      this.$store.dispatch("loadPaymentRate");
      /*
      const path = this.$global.endpoint + "/analytics/getpaymentdata";
      axios
        .post(path, {
          allProducts:true
        })
        .then(res => {
          this.paymentChartData = res.data;
        })
        .catch(error => {
          console.error(error);
        });
        */
    },
    getDailyPaymentData() {
      const path = this.$global.endpoint + "/analytics/getpaymentdata";
      axios
        .post(path, {
          allProducts: false
        })
        .then(res => {
          this.dailyChartData = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  created() {
    this.getStudentData();
    this.getUsers();
    this.getCourses();
    this.getPayments();
    this.getInactives();
    this.getPaymentData();
    this.getDailyPaymentData();
  }
};
</script>
